<template>
  <div @click="openDetails" class="fcl-list-row">
    <div class="fcl-list-body-item">{{ formatDate(item.end_date) }}</div>
    <div class="fcl-list-body-item">{{ item.weekday }}</div>
    <div class="fcl-list-body-item">${{ item.total.toFixed(2) }}</div>

    <div id="trans-detail" v-if="detail" class="trans-detail">
      <div class="trans-detail-head">
        <div class="trans-top-row row-head">
          <div class="trans-top-column">Deposit Date</div>
          <div class="trans-top-column">Transferred To</div>
        </div>
        <div class="trans-top-row row-body">
          <div class="trans-top-column">Period {{ formatDate(item.start_date) }} to {{formatDate(item.end_date)}}</div>
          <div class="trans-top-column">Account Ending in {{ stripeAccount.external_accounts.data[0].last4 }}</div>
        </div>
      </div>
      <div class="trans-detail-body">
        <div class="trans-body-head">
          <div class="trans-body-row">
            <div class="trans-body-column">
              Order Type
            </div>
            <div class="trans-body-column">
              Quantity
            </div>
            <div class="trans-body-column">
              Subtotal
            </div>
            <div class="trans-body-column">
              Sales Tax
            </div>
            <div class="trans-body-column">
              Tip
            </div>
            <div class="trans-body-column">
              Platform Fee
            </div>
            <div class="trans-body-column">
              Revenue
            </div>
          </div>
        </div>
        <div class="trans-body">
          <div class="trans-body-row">
            <div class="trans-body-column">
              {{ delivery_total.type }}
            </div>
            <div class="trans-body-column">
              {{ delivery_total.quantity }}
            </div>
            <div class="trans-body-column">
              ${{ delivery_total.subtotal }}
            </div>
            <div class="trans-body-column">
              ${{ delivery_total.tax }}
            </div>
            <div class="trans-body-column">
              ${{ delivery_total.tipPrice }}
            </div>
            <div class="trans-body-column">
              -${{ delivery_total.platform_fee }}
            </div>
            <div class="trans-body-column">
              ${{delivery_total.total.toFixed(2)}}
            </div>
          </div>
          <div class="trans-body-row">
            <div class="trans-body-column">
              {{ pickup_total.type }}
            </div>
            <div class="trans-body-column">
              {{ pickup_total.quantity }}
            </div>
            <div class="trans-body-column">
              ${{ pickup_total.subtotal }}
            </div>
            <div class="trans-body-column">
              ${{ pickup_total.tax }}
            </div>
            <div class="trans-body-column">
              ${{ pickup_total.tipPrice }}
            </div>
            <div class="trans-body-column">
              -${{ pickup_total.platform_fee }}
            </div>
            <div class="trans-body-column">
              ${{pickup_total.total.toFixed(2)}}
            </div>
          </div>
          <div class="trans-body-row summary">
            <div class="trans-body-column">

            </div>
            <div class="trans-body-column">
              {{ delivery_total.quantity + pickup_total.quantity }}
            </div>
            <div class="trans-body-column">
              ${{(parseFloat(delivery_total.subtotal) + parseFloat(pickup_total.subtotal)).toFixed(2)}}
            </div>
            <div class="trans-body-column">
              ${{(parseFloat(delivery_total.tax) + parseFloat(pickup_total.tax)).toFixed(2)}}
            </div>
            <div class="trans-body-column">
              ${{(parseFloat(delivery_total.tipPrice) + parseFloat(pickup_total.tipPrice)).toFixed(2)}}
            </div>
            <div class="trans-body-column">
              -${{(parseFloat(delivery_total.platform_fee) + parseFloat(pickup_total.platform_fee)).toFixed(2)}}
            </div>
            <div class="trans-body-column">
              ${{(parseFloat(delivery_total.total) + parseFloat(pickup_total.total)).toFixed(2)}}
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'FinancialItem',
  components: {
    moment
  },
  props: {
    item: {
      type: Object
    },
    stripeAccount: {
      type: Object
    }
  },
  computed: {

    delivery_total () {
      const type = 'Delivery'
      let quantity = 0
      let subtotal = 0
      let tax = 0
      let total = 0
      let platform_fee = 0
      let tipPrice = 0

      this.item.orders.map(order => {
        if (order.delivery_type === 1 && order.transfer) {
          quantity++
          subtotal += order.product_price
          total += (order.transfer.amount / 100)
          tax += parseFloat(order.tax)
          tipPrice += order.tip_price
          platform_fee += (order.total_amount - (order.transfer.amount / 100))
        }
      })


      return {
        type,
        quantity,
        total,
        subtotal: subtotal.toFixed(2),
        tax: parseFloat(tax).toFixed(2),
        platform_fee: platform_fee.toFixed(2),
        tipPrice: parseFloat(tipPrice).toFixed(2)

      }
    },
    pickup_total () {
      const type = 'Pick up'
      let quantity = 0
      let subtotal = 0
      let total = 0
      let tax = 0
      let platform_fee = 0
      let tipPrice = 0

      this.item.orders.map(order => {
        if (order.delivery_type === 2 && order.transfer) {
          quantity++
          subtotal += order.product_price
          total += (order.transfer.amount / 100)
          tax += parseFloat(order.tax)
          tipPrice += order.tip_price
          platform_fee += (order.total_amount - (order.transfer.amount / 100))
        }
      })


      return {
        type,
        quantity,
        total,
        subtotal: subtotal.toFixed(2),
        tax: parseFloat(tax).toFixed(2),
        platform_fee: platform_fee.toFixed(2),
        tipPrice: parseFloat(tipPrice).toFixed(2)
      }
    }
  },
  data () {
    return {
      detail: false
    }
  },
  methods: {
    formatDate (time) {
      return moment(time).format('MM/DD')
    },
    openDetails () {
      this.detail = !this.detail
    }
  }
}
</script>

<style scoped>

</style>
